import About from '@/pages/About.vue'
import Detail from '@/pages/Detail.vue'
import Home from '@/pages/Home.vue'
import IntegrationForm from '@/pages/IntegrationForm.vue'
import Integrations from '@/pages/Integrations.vue'
import Login from '@/pages/Login.vue'
import PartnerForm from '@/pages/PartnerForm.vue'
import Partners from '@/pages/Partners.vue'
import Queries from '@/pages/Queries.vue'
import RequestUpdate from '@/pages/RequestUpdate.vue'
import Router from 'vue-router'
import store from '@/stores/store'
import Vue from 'vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/about',
            name: 'about',
            component: About,
        },
        {
            path: '/app/:id',
            name: 'appDetail',
            component: Detail,
        },
        {
            path: '/app/update/:id/:platform',
            name: 'requestUpdate',
            component: RequestUpdate,
        },
        {
            path: '/app/update/new',
            name: 'requestUpdate',
            component: RequestUpdate,
        },
        {
            path: '/integrations',
            name: 'integrations',
            component: Integrations,
        },
        {
            path: '/integrations/update/:id',
            name: 'integrationForm',
            component: IntegrationForm,
        },
        {
            path: '/integrations/new',
            name: 'integrationForm',
            component: IntegrationForm,
        },
        {
            path: '/partners',
            name: 'partners',
            component: Partners,
        },
        {
            path: '/partners/create',
            name: 'partnersForm',
            component: PartnerForm,
        },
        {
            path: '/partners/update/:id',
            name: 'partnersForm',
            component: PartnerForm,
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/queries',
            name: 'queries',
            component: Queries,
        },
    ],
})

router.beforeEach((to, from, next) => {
    if (to.path === '/login' || store.getters.isAuthenticated) {
        next()
        return
    }
    next('/login')
})

export default router
